"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROJECT_HOME = void 0;
const react_1 = __importStar(require("react"));
const route_1 = require("../route");
const models_hook_1 = require("app/models.hook");
const auth_1 = require("common/auth");
const components_1 = require("utils/components");
const Usage_1 = require("../../../../components/Usage");
exports.PROJECT_HOME = route_1.PROJECT.sub("", ProjectHome);
function getRandomString(length) {
    const array = new Uint8Array(length);
    window.crypto.getRandomValues(array);
    return Array.from(array, (byte) => byte.toString(16).padStart(2, "0")).join("");
}
function ProjectHome({ projectId }) {
    const { data, loading } = (0, models_hook_1.useProjectDoc)({ projectId });
    const { user, loading: userLoading } = (0, auth_1.useAdminAuthentication)();
    const userId = user === null || user === void 0 ? void 0 : user.email;
    const { data: keyData, loading: keyLoading, upsert, } = (0, models_hook_1.useProjectKeyDoc)({ projectId, userId });
    const { list: usageList, loading: usageLoading } = (0, models_hook_1.useMonthlyUsageList)({
        projectId,
        userId,
    });
    console.log("useMonthlyUsageList", {
        projectId,
        userId,
        usageList,
    });
    const resetKey = (0, react_1.useCallback)(() => {
        upsert({ key: `${userId}:${projectId}:${getRandomString(24)}` });
    }, [upsert]);
    (0, react_1.useEffect)(() => {
        if (!keyLoading && !keyData.key) {
            resetKey();
        }
    }, [keyLoading, keyData, resetKey]);
    if (loading || userLoading) {
        return react_1.default.createElement(components_1.Loading, null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("section", { className: "hero" },
            react_1.default.createElement("div", { className: "hero-body" },
                react_1.default.createElement("h1", { className: "title" }, data === null || data === void 0 ? void 0 : data.projectName))),
        react_1.default.createElement("section", { className: "main-section" },
            react_1.default.createElement("div", null, user === null || user === void 0 ? void 0 :
                user.displayName,
                "\u3055\u3093\u306E", data === null || data === void 0 ? void 0 :
                data.projectName,
                "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306EAPI\u30AD\u30FC:",
                react_1.default.createElement("div", { className: "input-group mb-3", style: { maxWidth: "400px" } },
                    react_1.default.createElement("input", { type: "text", className: "form-control", value: keyData === null || keyData === void 0 ? void 0 : keyData.key, readOnly: true }),
                    react_1.default.createElement("div", { className: "input-group-append" },
                        react_1.default.createElement("button", { className: "btn btn-outline-secondary", type: "button", onClick: () => navigator.clipboard.writeText(keyData === null || keyData === void 0 ? void 0 : keyData.key) },
                            react_1.default.createElement("i", { className: "mdi mdi-content-copy" })))),
                react_1.default.createElement(components_1.Button, { onClick: resetKey }, "\u30EA\u30BB\u30C3\u30C8")),
            react_1.default.createElement("div", { className: "mt-4" },
                react_1.default.createElement("a", { href: "https://drive.google.com/open?id=1DO6GqynogXwm20SSWXzIfNt_YwVz6Q81&usp=drive_fs", target: "_blank", rel: "noopener noreferrer", className: "btn btn-primary" },
                    react_1.default.createElement("i", { className: "mdi mdi-download me-2" }),
                    "\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9")),
            react_1.default.createElement(Usage_1.Usage, { usageList: usageList || [] }))));
}
exports.default = ProjectHome;
